<h3 mat-dialog-title>
    {{ 'Approvals' }}
    <button mat-icon-button disableRipple mat-dialog-close><mat-icon>close</mat-icon></button>
</h3>

<mat-dialog-content>
    <app-request-form-submission-approvals [formSubmissionId]="data.formSubmission.id"></app-request-form-submission-approvals>
</mat-dialog-content>
